import { css } from "@emotion/css";
import { IconButton, SimpleMenu, useMenuState } from "@octopusdeploy/design-system-components";
import { CogIcon, PlusMinusIcon, TableColumnsIcon } from "@octopusdeploy/design-system-icons";
import { text, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import type { DiffViewType } from "~/components/DiffViewer/DiffViewer";
export type DiffSettings = {
    viewType: DiffViewType;
    hideUnchangedManifests: boolean;
};
const styles = {
    diffViewLabel: css({
        font: text.body.regular.medium,
        color: themeTokens.color.text.secondary,
    }),
};
type DiffConfigMenuProps = {
    diffSettings: DiffSettings;
    updateDiffSettings: (field: Partial<DiffSettings>) => void;
};
export const DiffConfigMenu = ({ diffSettings, updateDiffSettings }: DiffConfigMenuProps) => {
    const [onOpen, menuState, buttonAriaAttributes] = useMenuState();
    return (<>
            <IconButton customIcon={<CogIcon size={24}/>} onClick={onOpen}/>
            <SimpleMenu menuState={menuState} accessibleName={"Manifest diff menu"} items={[
            {
                type: "information",
                content: <span className={styles.diffViewLabel}>Diff view</span>,
            },
            {
                type: "icon-button",
                label: "Unified",
                icon: <PlusMinusIcon size={24}/>,
                autoFocus: false,
                isSelected: diffSettings.viewType === "unified",
                onClick: () => updateDiffSettings({ viewType: "unified" }),
                disableClose: false,
            },
            {
                type: "icon-button",
                label: "Split",
                icon: <TableColumnsIcon size={24}/>,
                autoFocus: false,
                isSelected: diffSettings.viewType === "split",
                onClick: () => updateDiffSettings({ viewType: "split" }),
                disableClose: false,
            },
            { type: "divider" },
            { type: "toggle", label: "Hide unchanged manifests", isEnabled: diffSettings.hideUnchangedManifests, setIsEnabled: (enabled) => updateDiffSettings({ hideUnchangedManifests: enabled }) },
        ]}/>
        </>);
};
